<div class="route-dialog-container">
    <app-dynamic [componentName]="data.headerName" [componentData]="headerModel"></app-dynamic>
    <div class="route-dialog-content" appTouchMoveListener (scroll)="onScroll($event)" [hidden]="loading">
        <router-outlet></router-outlet>
    </div>
</div>